module.exports = __webpack_public_path__ + "media/images/result_sets/circles/9r8n3r6n-7ead3d2a398bf63a826d8fea5be6f80f.svg";